import service from '@/store/services/profile-service';

const state = {
    me: null,
    role: null,
    order_page: null,
    worksheet: null,
};

const mutations = {
    SET_RESOURCE_ROLE: (state, role) => {
        state.role = role;
    },

    SET_RESOURCE_ORDER_PAGE: (state, order_page) => {
        state.order_page = order_page;
    },

    SET_RESOURCE: (state, me) => {
        state.me = me;
    },

    SET_WORKSHEET_RESOURCE: (state, worksheet) => {
        state.worksheet = worksheet;
    },

};

const actions = {
    me({commit, dispatch}, params) {
        return service.get(params)
            .then((profile) => {
                commit('SET_RESOURCE', profile.list);
            });
    },
    role({commit, dispatch}, params) {
        return service.get(params).then((profile) => {
           if (profile) {
              commit('SET_RESOURCE_ROLE', profile.role);
            }
        });
    },

    order_page({commit, dispatch}, params) {
        return service.get(params).then((profile) => {
            if (profile) {
               commit('SET_RESOURCE_ORDER_PAGE', profile.order_page);
            }
        });
    },

    update({commit, dispatch}, params) {
        return service.update(params)
            .then((profile) => {
                commit('SET_RESOURCE', profile);
            });
    },
    updateWorksheet({commit, dispatch}, params) {
        return service.updateWorksheet(params)
            .then((profile) => {
                commit('SET_WORKSHEET_RESOURCE', profile);
            });
    },
};

const getters = {
    me: state => getterKey => state.me,
    role: state => state.role,
    order_page: state => state.order_page,
    worksheet: state => state.worksheet
};

const profile = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default profile;
